import { Operation } from "rfc6902/diff";

import FetchFactory, {
	GetRequest,
	ModifyRequest
} from "utils/fetch/FetchRequest";

import { DashboardBlueprint } from "./DashboardTypes";
import { BlueprintInfo } from "../base/BlueprintService";

const ENDPOINT = "/api/blueprints/dashboards";

export default class DashboardBlueprintClient {
	public static getInfo(id: number): GetRequest<BlueprintInfo> {
		return FetchFactory.get(`${ENDPOINT}/${id}`);
	}

	public static getContent(id: number): GetRequest<DashboardBlueprint> {
		return FetchFactory.get(`${ENDPOINT}/${id}/content`);
	}

	public static updateContent(
		id: number,
		content: Operation[]
	): ModifyRequest<Operation[], void> {
		return {
			operation: "PATCH",
			url: `${ENDPOINT}/${id}/content`,
			body: content,
			statusCode: 200,
			callback: () => Promise.resolve()
		};
	}
}
